import { createSlice } from '@reduxjs/toolkit';

export const reportSlice = createSlice({
  name: 'report',
  initialState: {
    loading: false,
    error: null,
    grids: [
      {
        id: 'incentives-summary-report',
        metaData: {
          filters: [],
          options: [
            { option: 'GROUPBY_AM', value: true },
            { option: 'GROUPBY_PORTFOLIO', value: true },
          ],
          pagination: {
            page: 1,
            current: 1,
            pageSize: 10,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
      {
        id: 'agency-manager-report',
        metaData: {
          filters: [],
          pagination: {
            page: 1,
            current: 1,
            pageSize: 100,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [50, 100, 500],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
    ],
    gridTabs: [],
    activeTabIndex: null,
  },
  reducers: {
    updateTableMetaData: (state, { payload }) => {
      state.metaData = payload.metaData;
    },
    updateGridMetaData: (state, { payload: { metaData, gridId } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData = {
        ...state.grids[gridIndex].metaData,
        ...metaData,
      };
    },
    resetFilters: (state) => {
      state.metaData = {
        ...state.metaData,
        filters: [],
      };
    },
    resetGridFilters: (state, { payload: { gridId } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.filters = [];
    },
    updateGridFilters: (state, { payload: { gridId, filters } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.filters = filters;
    },
    updateGridOptions: (state, { payload: { gridId, option: newOption } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      const updatedOptions = state.grids[gridIndex].metaData.options.map(
        (i) => {
          if (i.option === newOption.option) {
            return {
              option: i.option,
              value: newOption.value,
            };
          } else {
            return i;
          }
        }
      );
      state.grids[gridIndex].metaData.options = updatedOptions;
    },
    updateVisibleColumns: (state, { payload: { gridId, visibleColumns } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.visibleColumns = visibleColumns;
      state.grids[gridIndex].metaData.exportColumns = visibleColumns;
    },
    updateExportColumns: (state, { payload: { gridId, exportColumns } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.exportColumns = exportColumns;
    },
  },
});

export const {
  updateTableMetaData,
  updateGridMetaData,
  resetFilters,
  resetGridFilters,
  updateVisibleColumns,
  updateExportColumns,
  updateGridOptions,
  updateGridFilters,
} = reportSlice.actions;

export default reportSlice.reducer;
